import { render, staticRenderFns } from "./worklocation.vue?vue&type=template&id=2d71dd6d&scoped=true"
import script from "./worklocation.vue?vue&type=script&lang=js"
export * from "./worklocation.vue?vue&type=script&lang=js"
import style0 from "./worklocation.vue?vue&type=style&index=0&id=2d71dd6d&prod&lang=css"
import style1 from "./worklocation.vue?vue&type=style&index=1&id=2d71dd6d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d71dd6d",
  null
  
)

export default component.exports